import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
	getBreachRiskClassificationList as getBreachRiskClassificationListApi,
	getBreachRiskClassificationListQuery as getBreachRiskClassificationListQueryApi,
	getBreachRiskClassificationById as getBreachRiskClassificationByIdApi,
	addNewBreachRiskClassificationApi,
	updateBreachRiskClassificationApi,
	deleteBreachRiskClassificationApi,
	checkBreachRiskClassificationExistsApi,
} from '../../helpers/breach_risk_classification/api_helper';

export const getBreachRiskClassificationList = createAsyncThunk(
	'breachRiskClassification/getBreachRiskClassificationList',
	async params => {
		try {
			const response = await getBreachRiskClassificationListApi(params);
			return response.data || response;
		} catch (error) {
			toast.error('Error al obtener clasificaciones de riesgo.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const getBreachRiskClassificationListQuery = createAsyncThunk(
	'breachRiskClassification/getBreachRiskClassificationListQuery',
	async params => {
		try {
			const response = getBreachRiskClassificationListQueryApi(params);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const getBreachRiskClassification = createAsyncThunk(
	'breachRiskClassification/getBreachRiskClassification',
	async id => {
		try {
			const response = await getBreachRiskClassificationByIdApi(id);
			return response;
		} catch (error) {
			toast.error('Error al obtener la clasificación de riesgo.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const addNewBreachRiskClassification = createAsyncThunk(
	'breachRiskClassification/addNewBreachRiskClassification',
	async breachRiskClassification => {
		try {
			const response = await addNewBreachRiskClassificationApi(breachRiskClassification);
			toast.success('Clasificación de Riesgo agregada exitosamente.', {
				autoClose: 3000,
			});
			return response.data || response;
		} catch (error) {
			toast.error('Error al agregar la clasificación de riesgo.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const updateBreachRiskClassification = createAsyncThunk(
	'breachRiskClassification/updateBreachRiskClassification',
	async breachRiskClassification => {
		try {
			const response = await updateBreachRiskClassificationApi(breachRiskClassification);
			toast.success('Clasificación de Riesgo actualizada exitosamente.', {
				autoClose: 3000,
			});
			return response.data || response;
		} catch (error) {
			toast.error('Error al actualizar la clasificación de riesgo.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const deleteBreachRiskClassification = createAsyncThunk(
	'breachRiskClassification/deleteBreachRiskClassification',
	async breachRiskClassification => {
		try {
			await deleteBreachRiskClassificationApi(breachRiskClassification._id);
			toast.success('Clasificación de Riesgo eliminada exitosamente.', {
				autoClose: 3000,
			});
			return breachRiskClassification;
		} catch (error) {
			toast.error('Error al eliminar la clasificación de riesgo.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const checkBreachRiskClassificationExists = createAsyncThunk(
	'breachRiskClassification/checkBreachRiskClassificationExists',
	async name => {
		try {
			const response = await checkBreachRiskClassificationExistsApi(name);
			return response;
		} catch (error) {
			return { exists: false };
		}
	}
);
